export enum CountdownItemVariant {
  Hours = 'Stunde',
  Minutes = 'Minute',
  Seconds = 'Sekunde',
}

export const CountdownItem = ({
  variant,
  value,
}: {
  variant: CountdownItemVariant;
  value: string | number;
}) => {
  return (
    <div className="CountdownItem">
      <strong className="CountdownItem__value">{value}</strong>
      <small className="CountdownItem__label">
        {variant}
        {value === 1 ? '' : 'n'}
      </small>
    </div>
  );
};
